/* unplugin-vue-components disabled */import { render } from "./clue-list.vue?vue&type=template&id=06c70e39&scoped=true"
import script from "./clue-list.vue?vue&type=script&lang=js"
export * from "./clue-list.vue?vue&type=script&lang=js"

import "./clue-list.vue?vue&type=style&index=0&id=06c70e39&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c70e39"]])

export default __exports__